import {
    BrushDasharrayType,
    BrushLinecapType,
    type IBrushAttribute,
    type IBrushLayerProps,
    type ILayerProps,
} from '@/version-types';

/** Brush 图层当前支持的线型组合，顺序与属性面板保持一致。 */
export const BRUSH_DASHARRAY_OPTIONS = [
    { value: BrushDasharrayType.Solid, linecap: BrushLinecapType.Square },
    { value: BrushDasharrayType.Solid, linecap: BrushLinecapType.Round },
    { value: BrushDasharrayType.Square, linecap: BrushLinecapType.Square },
    { value: BrushDasharrayType.Dot, linecap: BrushLinecapType.Round },
    { value: BrushDasharrayType.Dashed, linecap: BrushLinecapType.Round },
] as const;

const LEGACY_BRUSH_DASHARRAY_MAP: Readonly<Record<string, BrushDasharrayType>> = {
    '1,2': BrushDasharrayType.Square,
    '2,2,1,2': BrushDasharrayType.Dashed,
};

/** 将历史 Brush 线型值映射到当前枚举，未知值保持不变。 */
export function normalizeBrushDasharray(dasharray: string) {
    return LEGACY_BRUSH_DASHARRAY_MAP[dasharray] ?? dasharray;
}

function normalizeBrushAttributeDasharray(attribute?: IBrushAttribute) {
    if (!attribute) return;
    attribute.dasharray = normalizeBrushDasharray(attribute.dasharray) as BrushDasharrayType;
}

/** 统一归一化 Brush 图层的填充线和描边线型。 */
export function normalizeBrushLayerDasharray(layer: ILayerProps) {
    const data = layer.data as IBrushLayerProps;
    data.fills?.forEach(normalizeBrushAttributeDasharray);
    normalizeBrushAttributeDasharray(data.stroke);
    return layer;
}
